export const mixpanelEventNames = {
  ACCOUNT_SWITCHER: 'GTA > Account switcher',
  ACCOUNT: 'GTA > Account',
  APP_SWITCHER: 'GTA > App switcher',
  APP_SWITCH_BACK: 'GTA > App switch back',
  RESOLVE_GUIDED_SETUP: 'GTA > Resolve guided setup',
  HELP_DRAWER: 'GTA > Help drawer',
  LOCATIONS: 'GTA > Locations',
  NOTIFICATIONS_DRAWER: 'GTA > Notifications drawer',
  PARTNER_TOOLS_DRAWER: 'GTA > Partner tools drawer',
  PORTAL: 'GTA > Connected user',
  PROFILE_MENU: 'GTA > Profile menu',
  SETUP_DRAWER: 'GTA > Setup drawer',
  SIDEBAR: 'GTA > Sidebar',
  SIDERAIL: 'GTA > Siderail',
  FREE_TRIAL: 'CC Config > Goto Free Trial',
  DYNAMIC_SETUP_DRAWER: 'GTA > Dynamic setup drawer',
  GLOBAL_SEARCH: 'GTA > Global Search',
  RESOLVE_CONVERSION: 'GTA > Resolve conversion banner',
  SMS_CAMPAIGN: 'GTA > SMS Campaign',
  COPILOT_DRAWER: 'GTA > Copilot drawer',
  ASSIST_TO_RESOLVE_BANNER: 'GTA > Billing > Product migration banner - Options CTA',
}

export const mixpanelActions = {}
